export enum CertPeriodRecapFormField {
  CERT_PERIOD_RECAP_CONSENT = 'cert-period-recap/consent',
  CERT_PERIOD_RECAP_60_DAY_ER = 'cert-period-recap/care_status/60-day-er',
  CERT_PERIOD_RECAP_60_DAY_ER_NOTES = 'cert-period-recap/care_status/60-day-er-notes',
  CERT_PERIOD_RECAP_60_DAY_HOSPITAL = 'cert-period-recap/care_status/60-day-hospital',
  CERT_PERIOD_RECAP_60_DAY_HOSPITAL_NOTES = 'cert-period-recap/care_status/60-day-hospital-notes',
  CERT_PERIOD_RECAP_60_DAY_INJURIES = 'cert-period-recap/care_status/60-day-injuries',
  CERT_PERIOD_RECAP_60_DAY_INJURIES_NOTES = 'cert-period-recap/care_status/60-day-injuries-notes',
  CERT_PERIOD_RECAP_60_DAY_FALLS = 'cert-period-recap/care_status/60-day-falls',
  CERT_PERIOD_RECAP_60_DAY_FALLS_NOTES = 'cert-period-recap/care_status/60-day-falls-notes',
  CERT_PERIOD_RECAP_60_DAY_INFECTIONS = 'cert-period-recap/care_status/60-day-infections',
  CERT_PERIOD_RECAP_60_DAY_INFECTIONS_NOTES = 'cert-period-recap/care_status/60-day-infections-notes',
  CERT_PERIOD_RECAP_60_DAY_MD = 'cert-period-recap/care_status/60-day-md',
  CERT_PERIOD_RECAP_60_DAY_MD_NOTES = 'cert-period-recap/care_status/60-day-md-notes',
  CERT_PERIOD_RECAP_GOALS = 'cert-period-recap/goals',
  CERT_PERIOD_RECAP_INITIALS_AUTHORIZATION = 'cert-period-recap/initials-authorization'
}
